import { useAuth } from "./useAuth";
import { useShowSupportRequests } from "./useShowSupportRequests";

export const useSupportAccess = () => {
  const {
    isSupport,
    isAdmin,
    isSuperAdmin,
    isManager,
    isSupervisor,
    isLeader,
  } = useAuth();
  const supportRequestsEnabled = useShowSupportRequests();

  const isStaff = isSupport || isAdmin || isSuperAdmin;
  const leadsTeams = isManager || isSupervisor || isLeader;
  const isTeamLead = leadsTeams && !isStaff;

  return {
    isStaff,
    isTeamLead,
    // o suporte que também comanda equipe ganha a aba "Minha equipe"
    leadsTeams,
    teamRequests: false,
    teamSearchOnly: isTeamLead,
    supportRequestsEnabled,
  };
};
